import { createFileRoute, redirect } from '@tanstack/react-router';
import { AGGREGATE_NAMES } from 'cpool-constants';
import { schemaTemplateResolver_ListByDivisions } from 'cpool-tables/backend-resolvers';

import { ROLES } from '~/constants.ts';
import { authoriseUser } from '~/features/auth/utils/authoriseUser.ts';
import { getQueryOptions } from '~/queryUtils/getQueryOptions.ts';
import { useUserStore } from '~/store/userStore.ts';

const divisionsTemplatesQueryOptions = () => {
    return getQueryOptions({
        aggregateName: AGGREGATE_NAMES.TEMPLATE,
        resolverName: 'listByDivisions',
        schema: schemaTemplateResolver_ListByDivisions,
        searchParams: {},
    });
};

export const Route = createFileRoute('/_app/management/templates/divisions')({
    beforeLoad: ({ location }) => authoriseUser([ROLES.admin, ROLES.email_manager], location),
    loader: async ({ context, location }) => {
        const { user } = useUserStore.getState();
        if (!user) {
            throw redirect({ search: { redirect: location.href }, to: '/login' });
        }
        await context.queryClient.ensureQueryData(divisionsTemplatesQueryOptions());
    },
});
